import { render } from "./YourDetailsPIT copy.vue?vue&type=template&id=4075a540&scoped=true"
import script from "./YourDetailsPIT copy.vue?vue&type=script&lang=js"
export * from "./YourDetailsPIT copy.vue?vue&type=script&lang=js"

import "./YourDetailsPIT copy.vue?vue&type=style&index=0&id=4075a540&lang=scss"
import "./YourDetailsPIT copy.vue?vue&type=style&index=1&id=4075a540&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4075a540"]])

export default __exports__